import { render, staticRenderFns } from "./TransportadoraList.vue?vue&type=template&id=4fd0bf8b&scoped=true"
import script from "./TransportadoraList.vue?vue&type=script&lang=js"
export * from "./TransportadoraList.vue?vue&type=script&lang=js"
import style0 from "./TransportadoraList.vue?vue&type=style&index=0&id=4fd0bf8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd0bf8b",
  null
  
)

export default component.exports